import { Injectable } from '@angular/core';

@Injectable()
export class StockListStateService {

  public page = 1;

  public searchTerm = null;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/stock-list/stock-list-state.service.ts